import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(identifier, password);
      if (data.otp_required) {
        // Navigate to OTP verification page with the temporary token
        navigate('/verify-otp', {
          replace: true,
          state: { otp_token: data.otp_token, email_verified: data.email_verified },
        });
      } else if (!data.email_verified) {
        navigate('/email-pending', { replace: true });
      } else {
        navigate('/lung-cancer', { replace: true });
      }
    } catch (err) {
      const msg = err.response?.data?.error || 'Login failed. Please try again.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center" style={{ minHeight: '100vh', background: '#f5f7fb' }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-sm-10 col-md-8 col-lg-5">
            <div className="text-center mb-4">
              <img
                src={process.env.PUBLIC_URL + '/img/cancepro-logo.png'}
                alt="CancePro"
                width="60"
                height="60"
                className="mb-2"
              />
              <h2 className="fw-bold">CancePro MedX</h2>
              <p className="text-muted">Sign in to your account</p>
            </div>

            <div className="card">
              <div className="card-body p-4">
                {error && (
                  <div style={{ color: 'red', textAlign: 'center', fontSize: '13pt' }}>
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Email or User ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={identifier}
                      onChange={(e) => setIdentifier(e.target.value)}
                      placeholder="Enter your email or user ID"
                      required
                      autoFocus
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter your password"
                      required
                    />
                  </div>

                  <div className="d-grid">
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" />
                          Signing in...
                        </>
                      ) : (
                        'Sign In'
                      )}
                    </button>
                  </div>
                </form>

                <div className="text-center mt-3">
                  <span className="text-muted">Don't have an account? </span>
                  <Link to="/register">Sign Up</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
